import { Injectable } from '@angular/core';
import { GtmDataTypes } from '@common/interfaces/gtm-params';
import { FirebaseRemoteConfigService } from './firebase-remote-config.service';
import { getAnalytics, logEvent } from 'firebase/analytics';

// Declare dataLayer for TypeScript to recognize it
declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  private isAnalyticsEnabled = false;

  constructor(
    private firebaseRemoteConfigService: FirebaseRemoteConfigService
  ) {
    window.dataLayer = window.dataLayer || [];
  }

  pushToDataLayer(data: GtmDataTypes): void {
    if (window.dataLayer && this.isAnalyticsEnabled) {
      const mergedData = {
        event: data.event || '',
        environment: data.environment || '',
        user_id: data.user_id ?? undefined,
        items: data.items ?? undefined,
        Opportunity_name: data.Opportunity_name ?? undefined,
        Error_Message: data.Error_Message ?? undefined,
      };

      window.dataLayer.push(mergedData);
      logEvent(getAnalytics(), data.event as any, mergedData);
    } else return;
  }

  async updateAnalyticsStatus(): Promise<void> {
    try {
      this.isAnalyticsEnabled =
        await this.firebaseRemoteConfigService.getTurnOnAnalyticsValue();
    } catch (error) {
      this.isAnalyticsEnabled = false;
    }
  }
}
